import { cartClient } from '../common/cartClient';
import type { GetUserMeResponse, UpdateUserRequest, UpdateUserResponse } from './utils/types';

class UserAPIClient {
  public async getMe(): Promise<GetUserMeResponse> {
    try {
      const res = await cartClient.get('/user/me');
      return res.data;
    } catch (_e) {
      return null;
    }
  }

  public async updateUser(payload: UpdateUserRequest): Promise<UpdateUserResponse> {
    const res = await cartClient.put('/user/me', payload);
    return res.data;
  }
}

export const userAPIClient = new UserAPIClient();
